import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { ScrollText, Filter } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterModule, setFilterModule] = useState('');

  useEffect(() => {
    const params = {};
    if (filterModule && filterModule !== 'all') params.module = filterModule;
    api.get('/admin/audit-logs', { params }).then(r => {
      setLogs(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [filterModule]);

  return (
    <div data-testid="audit-logs-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#0F172A] tracking-tight">Auditoría</h1>
          <p className="text-sm text-[#64748B] mt-1">Registro de actividad del sistema</p>
        </div>
        <Select value={filterModule} onValueChange={setFilterModule}>
          <SelectTrigger className="w-full sm:w-[180px] bg-white border-[#E2E8F0] rounded-lg text-sm" data-testid="filter-audit-module">
            <Filter className="w-3.5 h-3.5 mr-2 text-[#94A3B8]" />
            <SelectValue placeholder="Módulo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="auth">Auth</SelectItem>
            <SelectItem value="admin">Admin</SelectItem>
            <SelectItem value="impersonation">Impersonación</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-xl overflow-hidden">
        {loading ? (
          <div className="flex justify-center py-16">
            <div className="w-8 h-8 border-2 border-[#E2E8F0] border-t-[#0F172A] rounded-full animate-spin" />
          </div>
        ) : logs.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-[#64748B]">
            <ScrollText className="w-12 h-12 mb-3 text-[#E2E8F0]" />
            <p className="text-sm">Sin registros de auditoría</p>
          </div>
        ) : (
          <div className="overflow-x-auto -mx-6 px-6">
            <table className="w-full min-w-[600px]" data-testid="audit-logs-table">
              <thead>
                <tr className="bg-[#F8F9FA]">
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Fecha</th>
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Acción</th>
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Módulo</th>
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Recurso</th>
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Fuente</th>
                  <th className="text-left text-xs uppercase tracking-widest text-[#64748B] font-semibold px-4 py-3">Resultado</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id} className="border-t border-[#E2E8F0] hover:bg-[#F8F9FA] transition-colors">
                    <td className="px-4 py-3 text-xs text-[#64748B]">
                      {new Date(log.timestamp_utc).toLocaleString('es-MX')}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-[#0F172A]">{log.action}</td>
                    <td className="px-4 py-3">
                      <span className="text-xs px-2 py-1 bg-[#F8F9FA] text-[#64748B] rounded-full border border-[#E2E8F0]">{log.module}</span>
                    </td>
                    <td className="px-4 py-3 text-xs text-[#64748B]">{log.resource_type || '-'}</td>
                    <td className="px-4 py-3">
                      <span className={`text-xs px-2 py-1 rounded-full font-medium border ${
                        log.source === 'impersonation' ? 'bg-pink-50 text-pink-700 border-pink-200' :
                        'bg-slate-50 text-slate-600 border-slate-200'
                      }`}>{log.source}</span>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`text-xs px-2 py-1 rounded-full font-medium border ${
                        log.result === 'success' ? 'bg-emerald-50 text-emerald-700 border-emerald-200' :
                        'bg-red-50 text-red-700 border-red-200'
                      }`}>{log.result}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
